export const getPublicPath = () => {
    return process.env.NODE_ENV === 'development' ? 'public/' : `${process.env.PUBLIC_URL}/`;
};
